/**
 * Copyright (c) Microblink Ltd. All rights reserved.
 */

/** List of supported alphabets. */
export enum AlphabetType
{
    Latin = 0,
    Arabic = 1,
    Cyrillic = 2,
    Greek = 3,
    Count = 4
}
